var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeLinejoin":"round","strokeWidth":"1"},React.createElement("g",{"stroke":"#142B6F","strokeWidth":"2"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M15.9952814,15.9952814 L3.99528137,3.99528137 L15.9952814,15.9952814 Z M15.9952814,3.99528137 L3.99528137,15.9952814 L15.9952814,3.99528137 Z","transform":"translate(-331.000000, -5849.000000) translate(24.000000, 3421.000000) translate(0.000000, 1892.000000) translate(0.000000, 282.000000) translate(307.000000, 254.000000) translate(9.995281, 9.995281) rotate(45.000000) translate(-9.995281, -9.995281)"}))))))));
}

IconPlus.defaultProps = {"width":"20","height":"20","version":"1.1","viewBox":"0 0 20 20"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
